// extracted by mini-css-extract-plugin
module.exports = {"groupTitle":"_1Rc-pkYA2CNW","groupWrapper":"_1nty1xpPHfy4","active":"_3jr2FQlnGeb-","reasons":"_3l2lqan3Rv8l","reason":"_1IewkWGzY8Nc"};